import Inputmask from 'inputmask'
import type React from 'react'
import { useEffect, useRef } from 'react'

const DefaultMaskOptions: Inputmask.Options = {
  placeholder: ' ',
  showMaskOnHover: false,
  showMaskOnFocus: false,
  jitMasking: true
}

export function useInputMask (
  ref: React.RefObject<HTMLInputElement>,
  mask: string
) {
  const inputmaskRef = useRef<Inputmask.Instance>()

  useEffect(() => {
    if (ref.current) {
      inputmaskRef.current = Inputmask(mask, DefaultMaskOptions).mask(ref.current)
    }
  }, [ref.current])

  const clearMask = () => {
    if (inputmaskRef.current) {
      inputmaskRef.current.setValue('')
    }
  }

  return { clearMask }
}
